module.exports = __webpack_public_path__ + "static/media/login-background.3f20ee77.png";